export const PARTNER_ID = 'DIG';
export const PRODUCT_CODE = 'BPK';
export const API_CONTEXT = 'digisme';
export const SOURCE_SYSTEM = 'DIG';
